import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { emitter, config } from "@/main";
import Index from "../pages/Index.vue";
import store from '../store';

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Index",
    component: Index,
  }, {
    path: "/platform-fees",
    name: "PlatformFees",
    component: () => import("../pages/PlatformFees.vue"),
  }, {
    path: "/commodities",
    name: "Commodities",
    component: () => import("../pages/Commodities.vue"),
  }, {
    path: "/products",
    name: "Products",
    component: () => import("../pages/Products.vue"),
  }, {
    path: "/commodities/:id",
    name: "Commodity",
    component: () => import("../pages/Commodity.vue"),
  }, {
    path: "/products/:id",
    name: "Product",
    component: () => import("../pages/Product.vue"),
  }, {
    path: "/account/verification",
    name: "AccountVerification",
    component: () => import("../pages/account/Verification.vue"),
  }, {
    path: "/account",
    name: "AccountOverview",
    component: () => import("../pages/account/Index.vue"),
  }, {
    path: "/account/asset-management",
    name: "AccountAssetManagement",
    component: () => import("../pages/account/AssetManagement.vue"),
  }, {
    path: "/account/shipping-cart",
    name: "AccountShippingCart",
    component: () => import("../pages/account/ShippingCart.vue"),
  }, {
    path: "/account/cash-balance",
    name: "AccountCashManagement",
    component: () => import("../pages/account/CashManagement.vue"),
  }, {
    path: "/account/pending-trades",
    name: "AccountPendingTrades",
    component: () => import("../pages/account/PendingTrades.vue"),
  },{
    path: "/account/completed-trades",
    name: "AccountCompletedTrades",
    component: () => import("../pages/account/CompletedTrades.vue"),
  },{
    path: "/account/shipping-history",
    name: "AccountShippingHistory",
    component: () => import("../pages/account/ShippingHistory.vue"),
  },{
    path: "/account/profile-settings",
    name: "ProfileSettings",
    component: () => import("../pages/account/ProfileSettings.vue"),
  }, {
    path: "/welcome",
    name: "Welcome",
    component: () => import(`../pages/welcome/WelcomeUSAE.vue`),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

const skipRegistration: string[] = []
const welcomeNavigation = ['/welcome', '/free-box-of-ammo'];

router.beforeEach((to, from, next) => {
  // @ts-ignore
  const { memberId, member, wasLoggedIn } = store.state.account;
  const isApproved = member.isApprovedTrader || member.isApprovedWholesaler;
  if (!memberId && config.forceRegistration && !skipRegistration.includes(to.path)) {
    const isDirectLoad = !from.matched.length;
    // after launch we should default to openRegister, but for now openLogin
    emitter.emit(wasLoggedIn ? 'openLogin' : 'openLogin', { forceOpen: isDirectLoad });
    next(false);
  } else if (memberId && !isApproved && !welcomeNavigation.includes(to.path)) {
    if (!welcomeNavigation.includes(from.path)) {
      next('/welcome');
    } else {
      next(false);
    }
  }
   else {
    emitter.emit('closeRegister');
    next();
  }
});

export default router;
